import { render, staticRenderFns } from "./SpiderChart2.vue?vue&type=template&id=5e3f2345&"
import script from "./SpiderChart2.vue?vue&type=script&lang=js&"
export * from "./SpiderChart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports